import React from "react";
import { Box, Link as MuiLink, Typography } from "@mui/material";

/**
 * Header 用の共通メニューアイテム（アイコン＋ラベル縦並び）
 * - link（href）/ action（onClick）両対応
 * - external=true の場合は別タブ
 */
const HeaderMenuItem = React.forwardRef(function HeaderMenuItem(
  { label, icon, href, onClick, external = false },
  ref,
) {
  // href があればリンク、なければボタン（アクション）として扱う
  const isLink = !!href;

  // Link/Button 共通の見た目
  const commonSx = {
    // button でも見た目を揃える
    border: "none",
    background: "transparent",
    cursor: "pointer",
    p: 0,

    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "4px",
    px: { xs: 1.5, sm: 2.5 },
    color: "#1e3a8a",
    transition: "transform 300ms ease, color 300ms ease",
    opacity: 1,

    "&:hover": {
      color: "#0f2a6d",
      transform: "translateY(-2px)",
    },
  };

  // 子要素側の hover 判定用（MuiLink-root に依存しないためのクラス）
  const wrapperClass = "header-menu-item";

  return (
    <>
      {isLink ? (
        // Link 表示（aタグ
        <MuiLink
          ref={ref}
          component="a"
          href={href}
          onClick={onClick}
          underline="none"
          target={external ? "_blank" : undefined}
          rel={external ? "noopener noreferrer" : undefined}
          className={wrapperClass}
          sx={commonSx}
        >
          {/* アイコン（あるときだけ表示） */}
          {icon && (
            <Box
              sx={{
                display: "inline-flex",
                transition: "transform 300ms ease",
                "& svg": { fontSize: { xs: 20, sm: 24 } },
                // 親の hover でアイコンを拡大
                [`.${wrapperClass}:hover &`]: { transform: "scale(1.1)" },
              }}
            >
              {icon}
            </Box>
          )}

          {/* ラベル */}
          <Typography
            sx={{
              fontSize: { xs: 9, sm: 11 },
              color: "black",
              position: "relative",
              transition: "color 300ms ease",
              // 親の hover で色変更
              [`.${wrapperClass}:hover &`]: { color: "#0f2a6d" },

              // 下線アニメーション
              "&::after": {
                content: '""',
                position: "absolute",
                left: "50%",
                bottom: -3,
                width: 0,
                height: 1.5,
                backgroundColor: "#0f2a6d",
                transition: "all 300ms ease",
              },
              [`.${wrapperClass}:hover &::after`]: {
                left: 0,
                width: "100%",
              },
            }}
          >
            {label}
          </Typography>
        </MuiLink>
      ) : (
        // Button 表示
        <Box
          ref={ref}
          component="button"
          type="button"
          onClick={onClick}
          className={wrapperClass}
          sx={commonSx}
        >
          {/* アイコン（あるときだけ表示） */}
          {icon && (
            <Box
              sx={{
                display: "inline-flex",
                transition: "transform 300ms ease",
                "& svg": { fontSize: { xs: 20, sm: 24 } },
                [`.${wrapperClass}:hover &`]: { transform: "scale(1.1)" },
              }}
            >
              {icon}
            </Box>
          )}

          {/* ラベル */}
          <Typography
            sx={{
              fontSize: { xs: 9, sm: 11 },
              color: "black",
              position: "relative",
              transition: "color 300ms ease",
              [`.${wrapperClass}:hover &`]: { color: "#0f2a6d" },
              "&::after": {
                content: '""',
                position: "absolute",
                left: "50%",
                bottom: -3,
                width: 0,
                height: 1.5,
                backgroundColor: "#0f2a6d",
                transition: "all 300ms ease",
              },
              [`.${wrapperClass}:hover &::after`]: {
                left: 0,
                width: "100%",
              },
            }}
          >
            {label}
          </Typography>
        </Box>
      )}
    </>
  );
});

export default HeaderMenuItem;
